import {
  DynamicModel,
  WithDimensionsReceivedProps,
  WithDimensionsSentProps,
  BasicDynamicModelEditor,
} from '@k3/core';
import {
  DefaultModelProps,
  Model,
} from '@k3/core/dist/src/lib/types/model.interface';
import { Stack } from '@mui/material';
import { ModelSelector } from './ModelSelector';
import { K3ModelsByKeys } from './K3ModelsByKey';
import { useRef, useState } from 'react';
import { Group, Mesh } from 'three';
import { useFrame } from '@react-three/fiber';

export const getTransformationSubmodelKeys = (model: Model) => {
  const props = model?.props as TransformationProps;

  return [...(props?.modelKeys ?? [])];
};

type TransformationProps = {
  modelKeys: string[];
};

type DynamicTransformationProps = WithDimensionsReceivedProps &
  DefaultModelProps &
  TransformationProps &
  Pick<Model, 'id'>;

const DynamicTransformation = (props: DynamicTransformationProps) => {
  const ref = useRef<Group>();
  const [userData, setUserData] = useState<{ modelId: number }>();

  useFrame(() => {
    if (ref.current && !userData) {
      let foundAMesh = false;
      ref.current.traverse((child) => {
        // Search if there is a mesh in the model and lets assume that when
        // this is the case everything is loaded.
        if (!foundAMesh && child instanceof Mesh) {
          setUserData({
            modelId: props.id,
          });
          foundAMesh = true;
        }
      });
    }
  });

  return (
    <group
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      ref={ref}
      scale={[props.width, props.height, props.depth]}
    >
      <group
        userData={userData}
        position={props.position}
        rotation={props.rotation}
        scale={props.scale}
      >
        <K3ModelsByKeys modelKeys={props.modelKeys} loadWithoutAction />
      </group>
    </group>
  );
};
export const transformation: DynamicModel<
  DynamicTransformationProps,
  WithDimensionsSentProps & TransformationProps
> = {
  type: 'transformation',
  label: 'Transformation',
  disabledForAR: false,
  component: (props) => {
    return <DynamicTransformation {...props} />;
  },
  propsDialog: (props) => {
    return (
      <Stack
        direction="column"
        spacing={4}
        sx={{
          width: '100%',
          maxWidth: 450,
          overflowX: 'hidden',
        }}
      >
        <BasicDynamicModelEditor {...props} materialsAreEditable={false} />

        <ModelSelector
          label={'Modelle'}
          multiple
          modelKey={props.dynamicModelProps.modelKeys ?? []}
          onChangeMultiple={props.onChange('modelKeys')}
        />
      </Stack>
    );
  },
  defaultProps: {
    width: { expression: '1' },
    height: { expression: '1' },
    depth: { expression: '1' },
    modelKeys: [],
  },
  materials: [],
};
